module.exports = __webpack_public_path__ + "static/media/011.302576a4.jpg";